// src/utils/tracking/linkedin.js
export const loadLinkedInInsight = () => {
  // Only load LinkedIn Insight in production
  const clientDomain = process.env.REACT_APP_CLIENT_DOMAIN;
  const isProduction =
    clientDomain && clientDomain.includes("www.plaintr.com");

  if (!isProduction || window._linkedin_data_partner_ids) return;

  window._linkedin_partner_id = "8402972";
  window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
  window._linkedin_data_partner_ids.push(window._linkedin_partner_id);

  const script = document.createElement("script");
  script.async = true;
  script.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";

  document.head.appendChild(script);
};
